/**
 * LoginScreen — the consumer front door (/login). Thin wrapper over the
 * persona-parameterized AuthLoginScreen (Track 0 persona-auth split, D6a).
 * All former LoginScreen behavior now lives in AuthLoginScreen persona="consumer"
 * (RHF + Zod, POST /auth/login, return_to / dashboard routing, error mapping,
 * OAuth handoff, the unverified-recovery link). See AuthLoginScreen for detail.
 */
import type { ReactElement } from "react";

import { AuthLoginScreen } from "@/features/auth/AuthLoginScreen";

export function LoginScreen(): ReactElement {
  return <AuthLoginScreen persona="consumer" />;
}

export default LoginScreen;
